"use client";

import { useState } from "react";
import styles from "./switcher-details.module.css";
import ListingCard from "./listing-card";
import { useTranslations } from "next-intl";
import { MdDone } from "react-icons/md";

export default function SwitcherAndDetails() {
  const [activePlan, setActivePlan] = useState("essential");
  const plans = ["essential", "plus", "prime", "spotlight"];

  const t = useTranslations("Pricing.Plans");

  return (
    <div className={styles.presentationWrapper}>
      <div className={styles.switcher}>
        {plans.map((plan) => (
          <button
            key={plan}
            className={`${styles[plan]} ${
              activePlan === plan ? styles.isActive : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              setActivePlan(plan);
            }}
          >
            {plan.charAt(0).toUpperCase() + plan.slice(1)}
          </button>
        ))}
      </div>
      <div className={styles.cardPresentation}>
        <ListingCard activePlan={activePlan} />
        <div className={styles.cardDetails}>
          <h3 className={styles.title}>
            {activePlan.charAt(0).toUpperCase() + activePlan.slice(1)}
          </h3>
          <p className={`${styles.description} ${styles[activePlan]}`}>
            {t(`${activePlan}.${"description"}`)}
          </p>
          <p className={styles.price}>
            <span className={styles.old}>€{planPrices[activePlan]}</span>
            <span className={styles.new}>€{planPrices[activePlan] / 2}</span>
            <span className={styles.unit}>/{t("month")}</span>
          </p>
          <ul className={styles.featuresList}>
            {planFeatures[activePlan].map((key, idx) => (
              <li key={idx} className={styles.featureItem}>
                <span className={styles.included}>
                  <MdDone />
                </span>{" "}
                {t(`${activePlan}.${key}`)}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

const planFeatures: Record<string, string[]> = {
  essential: [
    "feature1",
    "feature2",
    "feature3",
    "feature4",
    "feature5",
    "feature6",
  ],
  plus: ["feature1", "feature2", "feature3", "feature4", "feature5"],
  prime: [
    "feature1",
    "feature2",
    "feature3",
    "feature4",
    "feature5",
    "feature6",
    "feature7",
    "feature8",
  ],
  spotlight: [
    "feature1",
    "feature2",
    "feature3",
    "feature4",
    "feature5",
    "feature6",
    "feature7",
  ],
};

const planPrices: Record<string, number> = {
  essential: 9,
  plus: 19,
  prime: 39,
  spotlight: 79,
};
